/* eslint-disable no-unused-vars */
// 导航
import NavigationTop from './nav/navigation-top.vue'
import FooterCategory from './nav/footer-category.vue'
import DuiDropdownMenu from './nav/dui-dropdown-menu.vue'
import SubNav from './nav/sub-nav.vue'
// 广告
import BannerSwiperSlide from './swiper/banner-swiper-slide.vue'
import CheckeredPattern from './advertising-column/checkered-pattern'
import InnovationStory from './advertising-column/innovation-story'
import ChildModule from './advertising-column/child-module.vue'
// 产品
import ImageText from './product/image-text.vue'
import OverView from './product/overview.vue'
import VideoDisplay from './product/video-display.vue'

const components = [
  NavigationTop, FooterCategory, DuiDropdownMenu, SubNav, 
  BannerSwiperSlide, 
  CheckeredPattern, InnovationStory, ChildModule,
  ImageText, OverView, VideoDisplay
]

const component = {
  install: (Vue) => {
    components.forEach(item => {
      Vue.component(item.name, item)
    });
  }
}

export default component